import { Stage, Sprite, SpriteSheet, Ticker } from '@createjs/easeljs';
import { speaker } from './spritesheet-frames';

import speakerHeadExpressionForward from '../spritesheets/speaker/speaker_head_expressions_face_front.png';
import speakerHeadExpressionLeft from '../spritesheets/speaker/speaker_head_expressions_face_left.png';
import speakerHeadExpressionLeftUp from '../spritesheets/speaker/speaker_head_expressions_face_left_up.png';
import speakerHeadExpressionRight from '../spritesheets/speaker/speaker_head_expressions_face_right.png';
import speakerHeadExpressionRightUp from '../spritesheets/speaker/speaker_head_expressions_face_right_up.png';

import speakerBodyTap from '../spritesheets/speaker/speaker_body_tap.png';
import speakerBodyLeft from '../spritesheets/speaker/speaker_body_point_left.png';
import speakerBodyForward from '../spritesheets/speaker/speaker_body_point.png';
import speakerBodyRight from '../spritesheets/speaker/speaker_body_point_right.png';

import femaleMp from '../spritesheets/speaker/mp_female.png';
import maleMp from '../spritesheets/speaker/mp_male.png';

const headDirectionImages = {
    forward: speakerHeadExpressionForward,
    left: speakerHeadExpressionLeft,
    leftUp: speakerHeadExpressionLeftUp,
    right: speakerHeadExpressionRight,
    rightUp: speakerHeadExpressionRightUp,
};

const bodyDirectionImages = {
    tap: speakerBodyTap,
    forward: speakerBodyForward,
    left: speakerBodyLeft,
    right: speakerBodyRight,
};

class SpeakerAnimation {
    constructor() {
        this.stage = null;

        this.speakerHead = {
            forward: null,
            left: null,
            leftUp: null,
            right: null,
            rightUp: null,
        };

        this.speakerBody = {
            tap: null,
            forward: null,
            left: null,
            right: null,
        };

        this.mps = {
            forward: null,
            left: null,
            leftUp: null,
            right: null,
            rightUp: null,
        };

        this.currentHead = null;
        this.currentBody = 'tap';

        this._createHeadSprites();
        this._createBodySprites();
        this._createMpSprites();
    }

    _createHeadSprites() {
        for (const headDirection in headDirectionImages) {
            const spriteSheet = new SpriteSheet({
                images: [headDirectionImages[headDirection]],
                frames: speaker.head[headDirection].frames,
                animations: speaker.head[headDirection].animations,
            });

            this.speakerHead[headDirection] = new Sprite(spriteSheet, [
                headDirection,
            ]);
            this.speakerHead[headDirection].scaleY = this.speakerHead[
                headDirection
            ].scaleX = 1;
            this.speakerHead[headDirection].x = 472;
            this.speakerHead[headDirection].y = 50;
        }
    }

    _createBodySprites() {
        for (const bodyDirection in bodyDirectionImages) {
            const spriteSheet = new SpriteSheet({
                images: [bodyDirectionImages[bodyDirection]],
                frames: speaker.body[bodyDirection].frames,
                animations: speaker.body[bodyDirection].animations,
            });
            this.speakerBody[bodyDirection] = new Sprite(spriteSheet, [
                bodyDirection,
            ]);
            this.speakerBody[bodyDirection].x = 170;
            this.speakerBody[bodyDirection].y = 280;
        }
    }

    _createMpSprites() {
        const femaleSpriteSheetFull = new SpriteSheet({
            images: [femaleMp],
            frames: speaker.femaleMp.frames.full,
            animations: speaker.femaleMp.animations,
        });
        const maleSpriteSheetFull = new SpriteSheet({
            images: [maleMp],
            frames: speaker.maleMp.frames.full,
            animations: speaker.maleMp.animations,
        });
        const maleSpriteSheetHalf = new SpriteSheet({
            images: [maleMp],
            frames: speaker.maleMp.frames.half,
            animations: speaker.maleMp.animations,
        });

        this.mps.left = new Sprite(femaleSpriteSheetFull, 'sat');
        this.mps.left.x = 790;
        this.mps.left.y = 280;
        this.mps.left.scaleY = 0.7;

        this.mps.right = new Sprite(maleSpriteSheetFull, 'sat');
        this.mps.right.x = 300;
        this.mps.right.y = 280;
        this.mps.right.scaleY = this.mps.right.scaleX = 0.7;

        this.mps.rightUp = new Sprite(maleSpriteSheetHalf, 'sat');
        this.mps.rightUp.x = 195;
        this.mps.rightUp.y = 250;
        this.mps.rightUp.scaleY = this.mps.rightUp.scaleX = 0.5;

        this.mps.forward = new Sprite(femaleSpriteSheetFull, 'sat');
        this.mps.forward.x = 250;
        this.mps.forward.y = 250;
        this.mps.forward.scaleY = 1.5;
        this.mps.forward.scaleX = -1.5;

        this.mps.leftUp = new Sprite(maleSpriteSheetHalf, 'sat');
        this.mps.leftUp.x = 890;
        this.mps.leftUp.y = 260;
        this.mps.leftUp.scaleY = 0.5;
        this.mps.leftUp.scaleX = -0.5;
        this.mps.leftUp.rotation = 7;
    }

    _shrinkSpeaker() {
        for (const bodyDirection in bodyDirectionImages) {
            this.speakerBody[bodyDirection].scaleX = this.speakerBody[
                bodyDirection
            ].scaleY = 0.3;
            this.speakerBody[bodyDirection].x = 490;
            this.speakerBody[bodyDirection].y = 270;
        }

        for (const headDirection in headDirectionImages) {
            this.speakerHead[headDirection].scaleY = this.speakerHead[
                headDirection
            ].scaleX = 0.3;
            this.speakerHead[headDirection].x = 580;
            this.speakerHead[headDirection].y = 200;
        }
    }

    initialise(id, questionGame) {
        if (questionGame === true) {
            this._shrinkSpeaker();
        }
        this.stage = new Stage(id);
        this.stage.addChild(this.mps.forward);
        this.stage.addChild(this.mps.left);
        this.stage.addChild(this.mps.right);
        this.stage.addChild(this.mps.rightUp);
        this.stage.addChild(this.mps.leftUp);
        this.stage.addChild(this.speakerBody.tap);
        this.stage.addChild(this.speakerHead.forward);
        this.stage.update();
        Ticker.on('tick', this.stage);
    }

    destroy() {
        Ticker.off('tick', this.stage);
        this.stage.removeChild(this.speakerBody[this.currentBody]);
        this.stage.removeChild(this.speakerHead[this.currentHead]);
        this.stage.removeChild(this.mps.forward);
        this.stage.removeChild(this.mps.left);
        this.stage.removeChild(this.mps.right);
        this.stage.removeChild(this.mps.rightUp);
        this.stage.removeChild(this.mps.leftUp);
        this.stage.clear();
        this.stage.update();
    }

    showHead(head) {
        this.stage.removeChild(this.speakerHead[this.currentHead]);
        this.stage.addChild(this.speakerHead[head]);
        this.stage.update();
        this.currentHead = head;
    }

    showBody(body) {
        this.stage.removeChild(this.speakerHead[this.currentHead]);
        this.stage.removeChild(this.speakerBody[this.currentBody]);
        this.stage.addChild(this.speakerBody[body]);
        this.stage.addChild(this.speakerHead[this.currentHead]);
        this.speakerBody[body].gotoAndPlay(body);
        this.stage.update();
        this.currentBody = body;
    }

    mpStand(direction) {
        this.mps[direction].gotoAndPlay('stand');
    }

    mpSit(direction) {
        this.mps[direction].gotoAndPlay('sit');
    }
}

export { SpeakerAnimation };
